import styled from 'styled-components';

export const Wrapper = styled.div``;

export const MediaItemLink = styled.a`
	display: flex;
	align-items: center;
	justify-content: space-between;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
	padding: 2rem 3rem;
	color: ${({ theme }) => theme.colors.primary};
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	margin-bottom: 1.5rem;
	transition: border-color 150ms;

	&:hover {
		border-color: ${({ theme }) => theme.colors.borderDark};
	}
`;

export const MediaItemName = styled.div``;
